import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingButtonGroup } from 'foundations-components/transitional/components/FloatingButtonGroup';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = path => `editor.form.${path}`;
export const BaseButton = ({
  disabled = false,
  Icon,
  labelLangKey,
  testId = '',
  onClick
}) => {
  const toolTip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: langKey(labelLangKey)
  });
  return /*#__PURE__*/_jsx(IconButton, {
    tooltip: toolTip,
    disabled: disabled,
    "data-test-id": testId,
    onClick: onClick,
    size: "xs",
    children: /*#__PURE__*/_jsx(Icon, {
      size: "300"
    })
  });
};
export const InfoButton = ({
  onClick
}) => /*#__PURE__*/_jsx(BaseButton, {
  Icon: InfoIcon,
  labelLangKey: "formFields.info",
  onClick: onClick
});
export const DeleteButton = ({
  onClick
}) => /*#__PURE__*/_jsx(BaseButton, {
  Icon: DeleteIcon,
  labelLangKey: "formFields.delete",
  testId: "captcha-delete",
  onClick: onClick
});
const FormFieldFloatingInfoButtonGroup = ({
  handleDelete = () => {},
  handleInfo = () => {},
  children
}) => /*#__PURE__*/_jsx(FloatingButtonGroup, {
  buttonGroup: /*#__PURE__*/_jsxs(ButtonGroup, {
    children: [/*#__PURE__*/_jsx(InfoButton, {
      onClick: handleInfo
    }), /*#__PURE__*/_jsx(DeleteButton, {
      onClick: handleDelete
    })]
  }),
  children: children
});
export default FormFieldFloatingInfoButtonGroup;